import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { IPaymentItem } from '@webapp/quoter//interfaces/payment.interface';

@Component({
	selector: 'app-payment-item',
	imports: [NgClass],
	standalone: true,
	templateUrl: './payment-item.component.html',
	styleUrl: './payment-item.component.scss',
})
export class PaymentItemComponent {
	item = input<IPaymentItem>();
}
